import { render, staticRenderFns } from "./totalGraph.vue?vue&type=template&id=354ca1ac"
import script from "./totalGraph.js?vue&type=script&lang=js&external"
export * from "./totalGraph.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports